/* eslint-disable no-param-reassign */
import axios from 'axios';

const getBaseURL = config => {
  if (
    config.url.includes('product-transfer-orders') ||
    config.url.includes('auto-reconsignments') ||
    config.url.includes('reconsignments')
  ) {
    return process.env.REACT_APP_PRODUCT_OWNERSHIP_BASE_URL;
  }
  if (config.url.includes('user-profiles')) {
    return process.env.REACT_APP_USER_PROFILE_URL;
  }
  if (config.url.includes('notifications')) {
    return process.env.REACT_APP_NOTIFICATIONS_URL;
  }
  if (config.url.includes('subscription-plans')) {
    return process.env.REACT_APP_SWIFT_SETTINGS_URL;
  }
  if (config.url.includes('dispatching')) {
    return process.env.REACT_APP_DISPATCHING_BASE_URL;
  }
  if (config.url.includes('batches')) {
    return process.env.REACT_APP_PRODUCT_SHIPPING_BASE_URL;
  }
  if (config.url.includes('tims')) {
    return process.env.REACT_APP_ODS_BASE_URL;
  }
  return process.env.REACT_APP_PRODUCT_LOADING_BASE_URL;
};

/**
 * axios instance
 */
const instance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_URL,
});

instance.interceptors.request.use(
  config => {
    const oidcStorage = JSON.parse(
      sessionStorage.getItem(
        `oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`
      )
    );
    if (oidcStorage && oidcStorage.access_token) {
      config.headers.Authorization = `Bearer ${oidcStorage.access_token}`;
    }
    config.baseURL = getBaseURL(config);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default instance;
